import { useEffect, useState } from "react";
import { useLocale } from "@lib/i18n/navigation-pages-router";
import { useCurrentUser } from "@hooks/use-current-user";
import { getStoryblokStory } from "@utils/call-api/storyblok-call";
import StoryblokComponent from "@components/core/Storyblok/StoryblokComponent";

const NavSearchContainer = () => {
  const user = useCurrentUser();
  const locale = useLocale();
  const canPreview = Boolean(user?.permissions?.includes("storyblok"));

  const [story, setStory] = useState();

  useEffect(() => {
    const fetchStoryblokStory = async () => {
      const storySlug = `common/navsearch/${process.env.NEXT_PUBLIC_CUSTOMER}/navsearch`;
      const storyParams = {
        language: locale,
        ...(canPreview && { version: "draft" }),
      };

      const data = await getStoryblokStory(storySlug, storyParams);

      setStory(data.story);
    };

    fetchStoryblokStory();
  }, [canPreview, locale]);

  if (!story) return null;

  return <StoryblokComponent story={story} />;
};

export default NavSearchContainer;
